import Immutable from 'immutable';
import { FETCH_LATEST_TABS } from './../actions/homeActions';

const defaultState = Immutable.fromJS({
  latestTabs: []
});

const home = (state = defaultState, action) => {
  let newState;

  switch (action.type) {
    case FETCH_LATEST_TABS:
      newState = state.set('latestTabs', Immutable.fromJS(action.data));
      break;

    default:
      newState = state;
  }

  return newState;
};

export default home;



// WEBPACK FOOTER //
// ./src/reducers/home.js